import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  selectedOrderSetIds: [],
};

const orderReviewSlice = createSlice({
  name: "orderReview",
  initialState,
  reducers: {
    approveOrDenySuccess(state) {
      state.selectedOrderSetIds = [];
    },
    setOrderSetSelection(state, action) {
      state.selectedOrderSetIds = action.payload;
    },
  },
});

export const { approveOrDenySuccess, setOrderSetSelection } =
  orderReviewSlice.actions;

export default orderReviewSlice.reducer;
